import type { KeyboardAvoidingViewProps as BaseKeyboardAvoidingViewProps } from "react-native";
import { KeyboardAvoidingView as BaseKeyboardAvoidingView } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { LiveEventHeaderHeight } from "@/constants/UI";
import { useAppSelector } from "@/store/hooks";
import { selectIsEventBannerVisible } from "@/store/reducers/userPreferences";
import { isIOS } from "@/utils/platform.util";

type KeyboardAvoidingViewProps = Omit<
  BaseKeyboardAvoidingViewProps,
  "behavior"
>;

const KeyboardAvoidingView = ({
  children,
  keyboardVerticalOffset,
  ...props
}: KeyboardAvoidingViewProps) => {
  const insets = useSafeAreaInsets();

  const isEventBannerVisible = useAppSelector(selectIsEventBannerVisible);
  const iOSVerticalOffset = isEventBannerVisible
    ? LiveEventHeaderHeight
    : insets.top;

  const defaultKeyboardVerticalOffset = isIOS() ? iOSVerticalOffset : 0;
  const appliedKeyboardVerticalOffset =
    keyboardVerticalOffset ?? defaultKeyboardVerticalOffset;

  return (
    <BaseKeyboardAvoidingView
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      behavior={isIOS() ? "padding" : undefined}
      keyboardVerticalOffset={appliedKeyboardVerticalOffset}
    >
      {children}
    </BaseKeyboardAvoidingView>
  );
};

export default KeyboardAvoidingView;
